/* eslint-disable */

import axios from "axios";

// export const axiosRequest = async (url, data) => {
//   const response = await axios.post(url, data, {});
//   return response.data;
// };

export const axiosRequest = async (url, data, config = {}) => {
  const { headers: extraHeaders = {}, ...axiosRest } = config;
  const merged = {
    headers: {
      "Content-Type": "application/json",
      ...extraHeaders,
    },
    ...axiosRest,
  };

  const response = await axios.post(url, data, merged);
  return response.data;
};
